<script lang="ts">
	export let disabled = false,
		selected = false,
		hovered = false,
		hidden = false;
</script>

<div class="option" class:disabled class:selected class:hidden class:hovered on:click on:keydown>
	<slot />
</div>

<style>
	.option {
		max-width: 100%;
		padding: 8px;
		cursor: pointer;
		color: var(--color-white);
		background-color: var(--color-base);
		display: flex;
		align-items: center;
		transition: all 0.33s;
		border-bottom: 1px solid var(--color-3);
		scroll-snap-align: start;
		line-height: 1em;
		font-size: 13px;
	}

	.option:first-child {
		border-top: 1px solid var(--color-secondary);
	}

	.option:last-child {
		border-bottom: none;
	}

	.option.hovered,
	.option.selected {
		background-color: var(--color-primary-10);
		/* color: var(--color-secondary);
		background-color: var(--color-primary); */
	}

	.option.disabled {
		pointer-events: none;
		opacity: var(--color-1-opacity);
	}

	.option.hidden {
		display: none;
	}
</style>
